import axios from 'axios';
import router from '../router/index';

let request = null;

class Api {
  initAxios() {
    request = axios.create({
      baseURL: process.env.VUE_APP_API_ENDPOINTS,
      headers: {
        Authorization: `Bearer TODO`,
      },
    });

    request.interceptors.response.use(
      function(response) {
        return response;
      },
      function(error) {
        router.push('/error');
        return Promise.reject(error);
      }
    );
  }

  sendEmail(body) {
    return request.post('email/' + window.sessionStorage.getItem('storeId'), null, {
      params: {
        message: body,
      },
    });
  }

  acceptCgu() {
    return request.post('account/' + window.sessionStorage.getItem('storeId') + '/acceptcgu');
  }

  updateProducts(body) {
    return request.put('account/' + window.sessionStorage.getItem('storeId'), body);
  }

  getGammes() {
    //return request.get(process.env.VUE_APP_API_ACCOUNT);

    return request.get('account/' + window.sessionStorage.getItem('storeId'));
    //return axios.get('/db.json');
  }

  getWebControls() {
    return request.get(process.env.VUE_APP_API_WEBCONTROL);
    //return axios.get('/WebControl.json');
  }

  getMedias() {
    return request.get(process.env.VUE_APP_API_MEDIA);
  }

  getVisionCategory() {
    return request.get(process.env.VUE_APP_API_UNDERSTAND);
    //return axios.get('/VisionCategory.json');
  }

  getProduct() {
    return request.get(process.env.VUE_APP_API_PRODUCT);
  }
}

export default new Api();
